export default __webpack_public_path__ + "static/media/small-pin.de76afe3.svg";